import React, { useEffect, lazy, Suspense } from 'react';
import styled from 'styled-components';
import { CameraViewTypes } from './weatherTrafficViewTypes';
// import { MobileViewTopBannerAd } from './mobileViewTopBannerAd';
import { DisplayCameraUI } from './displayCameraUI';
import { WeatherTrafficNavigation } from '../subNavigation/weatherTrafficNavigation';

const MobileViewTopBannerAd = lazy(() => import('./mobileViewTopBannerAd'));
interface WeatherTrafficCamContainerViewProps {
    cameraPageViewType: CameraViewTypes;
}

export const WeatherTrafficCamContainerView = (
    {
        cameraPageViewType
    }: WeatherTrafficCamContainerViewProps
) => {

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [cameraPageViewType]);

    return (
        <Container>
            <WeatherTrafficNavigation />
            <Suspense fallback={<div></div>}>
                <MobileViewTopBannerAd camViewType={cameraPageViewType} />
            </Suspense>
            <DisplayCameraUI camViewType={cameraPageViewType} />
        </Container>
    );
};

WeatherTrafficCamContainerView.displayName = 'WeatherTrafficCamContainerView';

const Container = styled.div`
    width: 100%;
    display: inline-block;
    height: auto;
    margin: 0 auto;
    margin-top: -21px;
    margin-bottom: -21px;
    background-size: 100% 531px;
`;